import {
  CONFIRMED_CREATE_PATIENT_ACTION,
  CONFIRMED_DELETE_PATIENT_ACTION,
  CONFIRMED_EDIT_PATIENT_ACTION,
  CONFIRMED_GET_PATIENTS,
  CONFIRMED_ADD_MARRIAGE_INFO,
  CONFIRMED_ADD_ADDRESS_INFO,
  CONFIRMED_ADD_OTHER_INFO,
  CONFIRMED_GET_PATIENTS_BY_GENDER,
  CONFIRMED_GET_PATIENT_DETAILS,
  FETCH_FAMILY_TREE_LIST_SUCCESS,
  CONFIRMED_ADD_FAMILY_TREE,
  CONFIRMED_EDIT_FAMILY_TREE,
  CONFIRMED_DELETE_FAMILY_TREE,
} from "../actions/PatientsTypes";

import {
  createPatient,
  formatPatients,
  getPatients,
  deletePatient,
  updatePatient,
  addMarriageInfo,
  addAddressInfo,
  addOtherInfo,
  getPatientlistbygender,
  getPatientDetails,
  getFamilyTreeList, addFamilyTree,
  editFamilyTree,
  deleteFamilyTree,
} from "../../services/PatientsService";
import {
  handleError,
  handleSuccess,
  showErrorAlert,
} from "../../services/ErrorHandlingService";

import { getDiseaseHistoryAction } from "./DiseaseHistoryAction";

// Get token from Redux or fallback to localStorage
function getAuthToken(getState) {
  // const stateToken = getState().auth?.authKey;
  // if (stateToken) return stateToken;

  const token = localStorage.getItem("token");
  console.log("token Action->", token);
  return token;
}

// export function getPatientsAction(pagination = false, pageid = 0, search_by = "", search_keyword = "",sort_order = "",sort_by="") {
//   return async (dispatch, getState) => {
//     try {
//       // const token = getAuthToken(getState);
//       // console.log("tokenindispatch", token);
//       // console.log("Parameters", admin_id, pagination, pageid, token);
//       const response = await getPatients(pagination, pageid, search_by, search_keyword,sort_order,sort_by);

//       if (response && response.status === 200 && response.data) {
//         if (response.data.status === "success" && response.data.data) {
//           const patients = formatPatients(response.data.data);
//           dispatch({ type: CONFIRMED_GET_PATIENTS, payload: patients });
//         } else {
//           handleError("Failed to get patients: Server error", "error");
//         }
//       } else {
//         handleError("Failed to get patients: Network error", "error");
//       }
//     } catch (error) {
//       console.error("API Error:", error.response || error);
//       showErrorAlert("Failed to get patients");
//     }
//   };
// }
export function getPatientsAction(
  pagination = false,
  pageid = 0,
  search_by = "",
  search_keyword = "",
  sort_order = "",
  sort_by = ""
) {
  return async (dispatch, getState) => {
    try {
      const response = await getPatients(
        pagination,
        pageid,
        search_by,
        search_keyword,
        sort_order,
        sort_by
      );
      
      if (response && response.status === 200 && response.data) {
        if (response.data.status === "success" && response.data.data) {
          const patients = formatPatients(response.data.data);
          dispatch({
            type: CONFIRMED_GET_PATIENTS,
            payload: {
              patients: patients,
              num_rows: response.data.num_rows || 0
            }
          });
        } else {
          handleError("Failed to get patients: Server error", "error");
        }
      } else {
        handleError("Failed to get patients: Network error", "error");
      }
    } catch (error) {
      console.error("API Error:", error.response || error);
      showErrorAlert("Failed to get patients");
    }
  };
}

export function getPatientlistbygenderAction(gender) {
  return async (dispatch, getState) => {
    try {
      const response = await getPatientlistbygender(gender);

      if (
        response?.status === 200 &&
        response.data?.status === "success" &&
        response.data?.data
      ) {
        const patients = formatPatients(response.data.data); // Format patient data
        dispatch({ type: CONFIRMED_GET_PATIENTS_BY_GENDER, payload: patients });
      } else {
        (
          
          "Failed to get patient list by gender: Server error"
        );
      }
    } catch (error) {
      console.error("API Error:", error?.response || error);
      ("Failed to get patient list by gender");
    }
  };
}
export function getPatientDetailsAction(patient_id) {
  return async (dispatch, getState) => {
    try {
      const token = getAuthToken(getState);
      const response = await getPatientDetails(patient_id);
      console.log("API Response:", response);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_GET_PATIENT_DETAILS,
          payload: response.data.data,
        });
      } else {
        ("Failed to get patient details");
      }
    } catch (error) {
      console.error("API Error:", error);
      (error.message || "Failed to get patient details");
    }
  };
}

export function deletePatientAction(patient, history) {
  return async (dispatch) => {
    try {
      await deletePatient(patient);
      dispatch({
        type: CONFIRMED_DELETE_PATIENT_ACTION,
        payload: { patient_id: patient.patient_id },
      });
      if (history) history.push("/patientspage");
      //handleSuccess("Success", "Patient deleted successfully!");
    } catch (error) {
      console.error(error);
      ("Failed to delete patient");
    }
  };
}

export function createPatientAction(formData) {
  return async (dispatch) => {
    try {
      const patientData = {
        branch: formData.branch,
        first_name: formData.first_name,
        middile_name: formData.middle_name || "",
        last_name: formData.last_name,
        patient_email: formData.patient_email || "",
        whatsapp_contact_no: formData.whatsapp_contact_no,
        additional_contact_no: formData.additional_contact_no || "",
        gender: formData.gender,
        date_of_birth: formData.date_of_birth,
        height: formData.height || "",
        weight: formData.weight || "",
        occupation: formData.occupation || "",
        id_proof: formData.id_proof || "",
        id_number: formData.id_number || "",
        disease_names: Array.isArray(formData.disease_names)
          ? formData.disease_names.join("|")
          : formData.disease_names || "",
        patient_photo: formData.patient_photo || null,
        //current_disease_id: formData.current_disease_id || formData.currentDiseaseId || "",
      };

      console.log("Sending patient data:", patientData);

      const response = await createPatient(patientData);
      console.log("Patient API response:", response?.data);

      if (
        response?.data?.status === "success" &&
        response?.data?.data?.patient_id
      ) {
        const patient_id = response.data.data.patient_id;

        dispatch({
          type: CONFIRMED_CREATE_PATIENT_ACTION,
          payload: response.data.data,
        });

        return {
          success: true,
          patient_id,
          data: response.data.data,
        };
      } else {
        throw new Error(response?.data?.message || "Failed to create patient");
      }
    } catch (error) {
      console.error("Create patient error:", error);
      dispatch({
        type: "FAILED_CREATE_PATIENT_ACTION",
        payload: error.message,
      });
      throw error;
    }
  };
}

export function addMarriageInfoAction(marriageData) {
  return async (dispatch, getState) => {
    try {
      console.log("Marriage Data to send:", marriageData);
      const response = await addMarriageInfo({
        admin_id: marriageData.admin_id,
        patient_id: marriageData.patient_id,
        is_married: marriageData.is_married,
        marriageHistory:
          marriageData.is_married === "Yes"
            ? JSON.stringify(marriageData.marriage_entries)
            : null,
      });

      console.log("API raw response:", response);

      if (response?.data) {
        dispatch({
          type: CONFIRMED_ADD_MARRIAGE_INFO,
          payload: response.data.data,
        });
        return true;
      }

      throw new Error("Unexpected response format");
    } catch (error) {
      console.error(
        "Marriage Info Error:",
        error.response?.data || error.message
      );
    }
  };
}

export function addAddressInfoAction(addressData) {
  return async (dispatch, getState) => {
    try {
      // const token = getAuthToken(getState);
      // console.log("add the address info", token);
      // console.log("address ==> ", addressData);
      const response = await addAddressInfo({
        patient_id: addressData.patient_id,
        temporaryAddress: addressData.temporary_address,
        permanentAddress: addressData.permanent_address,
      });

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_ADD_ADDRESS_INFO,
          payload: response.data.data,
        });
        return true;
      }

      throw new Error("Failed to add address info");
    } catch (error) {
      console.error("Add address info error:", error);
      dispatch({ type: "FAILED_ADD_ADDRESS_INFO", payload: error.message });
      throw error;
    }
  };
}

export function addOtherInfoAction(formData, navigate) {
  return async (dispatch) => {
    try {
      console.log("Submitting Other Info...", formData);

      const response = await addOtherInfo({
        patient_id: formData.patient_id,
        ad_name: formData.ad_name ?? "",
        ad_set: formData.ad_Set ?? "",
        campaign_name: formData.campaign_name ?? "",
        lead_source: formData.lead_source ?? "",
        status: formData.status ?? "",
        priority: formData.priority ?? "",
        modified_by: formData.modified_by ?? "",
        user_type: formData.user_type ?? "",
        treatment_history: formData.treatment_history ?? "",
      });

      console.log("Payload sent to addOtherInfo API:", formData);
      console.log("Response from API:", response?.data);

      if (response?.data?.status === "success") {
        dispatch({
          type: CONFIRMED_ADD_OTHER_INFO,
          payload: response.data.data,
        });

        // Return success status instead of navigating here
        return { success: true, data: response.data.data };
      }

      throw new Error("Failed to add other info");
    } catch (error) {
      console.error("Add other info error:", error);
      throw error;
    }
  };
}

// export function updatePatientAction(patientData, patientId, history) {
//   return async (dispatch) => {
//     try {
//       let response = await updatePatient(patientData, patientId);
//       if (response) {
//         dispatch({ type: CONFIRMED_EDIT_PATIENT_ACTION, payload: patientData });
//         if (history) history.push("/app-patients");
//       } else {
//         swal("Failed to update patient", "error");
//       }
//     } catch (error) {
//       console.log(error);
//       swal("Failed to update patient", "error");
//     }
//   };
// }
export function updatePatientAction(formData) {
  return async (dispatch) => {
    try {
      const patientData = {
        patient_id: formData.patient_id,
        branch: formData.branch,
        first_name: formData.first_name,
        middile_name: formData.middle_name || "",
        last_name: formData.last_name,
        patient_email: formData.patient_email || "",
        whatsapp_contact_no: formData.whatsapp_contact_no,
        additional_contact_no: formData.additional_contact_no || "",
        gender: formData.gender,
        date_of_birth: formData.date_of_birth,
        height: formData.height || "",
        weight: formData.weight || "",
        occupation: formData.occupation || "",
        id_proof: formData.id_proof || "",
        id_number: formData.id_number || "",
        disease_names: Array.isArray(formData.disease_names)
          ? formData.disease_names.join("|")
          : formData.disease_names || "",
        patient_photo: formData.patient_photo || null,
        current_disease_id: formData.current_disease_id || formData.currentDiseaseId || "",
        disease_status: formData.disease_status || formData.diseaseStatus || "",
        disease_percentage: formData.disease_percentage || "",
        intensity_of_treatment: formData.intensity_of_treatment || "",
        referred_by: formData.referred_by || "",
        referred_by_manual:formData.referred_by_manual||"",

      };

      console.log("Sending patient update data:", patientData)

      const response = await updatePatient(patientData)
      console.log("Patient update API response:", response?.data)

      if (response?.data?.status === "success") {
        const updatedData = {
          ...response.data.data,
          disease_status: patientData.disease_status,
          current_disease_id: patientData.current_disease_id,
          patient_id: response.data.data?.patient_id || patientData.patient_id,
        }

        dispatch({ type: CONFIRMED_EDIT_PATIENT_ACTION, payload: updatedData })

        dispatch(getDiseaseHistoryAction(updatedData.patient_id))

        return { patient_id: updatedData.patient_id }
      } else {
        throw new Error(response?.data?.message || "Failed to update patient")
      }
    } catch (error) {
      console.error("Update patient error:", error)
      throw error
    }
  }
}


export function fetchFamilyTreeListAction(patientId) {
  return async (dispatch) => {
    try {
      const response = await getFamilyTreeList(patientId)
      if (response?.status === 200 && Array.isArray(response.data?.data)) {
        dispatch({
          type: FETCH_FAMILY_TREE_LIST_SUCCESS,
          payload: response.data.data, // ✅ Only the array
        })
      } else {
        showErrorAlert("Failed to fetch family tree list.")
      }
    } catch (error) {
      console.error("API Error:", error)
      showErrorAlert("Failed to fetch family tree list.")
      throw error
    }
  }
}

// Add a new family relationship
export function addFamilyTreeAction(patient_id, family_patient_id,relation_name) {
  return async (dispatch) => {
    const payload = { patient_id, family_patient_id,relation_name }

    try {
      const response = await addFamilyTree(payload)
      if (response?.status === 200 && response.data) {
        dispatch({
          type: CONFIRMED_ADD_FAMILY_TREE,
          payload,
        })
        //handleSuccess("Family tree entry added successfully!")
      } else {
        showErrorAlert("Failed to add family tree entry.")
      }
    } catch (error) {
      console.error("API Error:", error)
      showErrorAlert("Failed to add family tree entry.")
      throw error
    }
  }
}
export function editFamilyTreeAction(patient_id, family_patient_id, relation_name, family_id) {
  return async (dispatch) => {
    const payload = { patient_id, family_patient_id, relation_name, family_id }

    try {
      const response = await editFamilyTree(payload)
      if (response?.status === 200 && response.data) {
        dispatch({
          type: CONFIRMED_EDIT_FAMILY_TREE,
          payload,
        })
        handleSuccess("Family tree entry updated successfully!")
      } else {
        showErrorAlert("Failed to update family tree entry.")
      }
    } catch (error) {
      console.error("API Error:", error)
      showErrorAlert("Failed to update family tree entry.")
      throw error
    }
  }
}

export function deleteFamilyTreeAction(family_id) {
  return async (dispatch) => {
    const payload = { family_id }

    try {
      const response = await deleteFamilyTree(payload)
      if (response?.status === 200 && response.data) {
        dispatch({
          type: CONFIRMED_DELETE_FAMILY_TREE,
          payload: { family_id },
        })
        handleSuccess("Family tree entry deleted successfully!")
      } else {
        showErrorAlert("Failed to delete family tree entry.")
      }
    } catch (error) {
      console.error("API Error:", error)
      showErrorAlert("Failed to delete family tree entry.")
      throw error
    }
  }
}
// export function updatePatientAction(formData, patientId) {
//   return async (dispatch) => {
//     try {
//       const patientData = {
//         patient_id: formData.patient_id || patientId,
//         branch: formData.branch,
//         first_name: formData.first_name,
//         middile_name: formData.middle_name || "",
//         last_name: formData.last_name,
//         patient_email: formData.patient_email || "",
//         whatsapp_contact_no: formData.whatsapp_contact_no,
//         additional_contact_no: formData.additional_contact_no || "",
//         gender: formData.gender,
//         date_of_birth: formData.date_of_birth,
//         height: formData.height || "",
//         weight: formData.weight || "",
//         occupation: formData.occupation || "",
//         id_proof: formData.id_proof || "",
//         id_number: formData.id_number || "",
//         disease_names: Array.isArray(formData.disease_names)
//           ? formData.disease_names.join("|")
//           : formData.disease_names || "",
//         patient_photo: formData.patient_photo || null,
//       };

//       console.log("Sending patient update data:", patientData);
//       // const token = getAuthToken(getState);
//       const response = await updatePatient(patientData, patientId);
//       console.log("Patient update API response:", response?.data);

//       if (response?.data?.status === "success") {
//         const updatedData = {
//           ...response.data.data,
//           patient_id: response.data.data?.patient_id || patientData.patient_id,
//         };

//         dispatch({
//           type: CONFIRMED_EDIT_PATIENT_ACTION,
//           payload: updatedData,
//         });

//         swal("Success", "Patient updated successfully", "success");

//         return { patient_id: updatedData.patient_id };
//       } else {
//         throw new Error(response?.data?.message || "Failed to update patient");
//       }
//     } catch (error) {
//       console.error("Update patient error:", error);
//       swal(error.message || "Failed to update patient", "error");
//       dispatch({
//         type: "FAILED_EDIT_PATIENT_ACTION",
//         payload: error.message,
//       });
//       throw error;
//     }
//   };
// }
